<script lang="ts">
  // CSS only; hidden dots keep their box so the label never shifts.
</script>

<span class="animated-dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>

<style>
  .animated-dots {
    display: inline-block;
    white-space: nowrap;
    letter-spacing: 0.05em;
  }
  .animated-dots span:nth-child(2) {
    animation: vd-dot-2 1.2s step-end infinite;
  }
  .animated-dots span:nth-child(3) {
    animation: vd-dot-3 1.2s step-end infinite;
  }
  @keyframes vd-dot-2 {
    0% {
      opacity: 0;
    }
    33% {
      opacity: 1;
    }
  }
  @keyframes vd-dot-3 {
    0% {
      opacity: 0;
    }
    66% {
      opacity: 1;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .animated-dots span {
      animation: none !important;
    }
  }
</style>
